import { Card, CardHeader, CardTitle, CardContent, Button } from '@cortexapps/react-plugin-ui';

function App() {
  // Create a click handler
  const handleClick = () => {
    alert('Button clicked! 🚀');
  };

  return (
    <div style={{ padding: "32px" }}>
      <Card>
        <CardHeader>
          <CardTitle>Hello from my first Cortex plugin! 🎉</CardTitle>
        </CardHeader>
        <CardContent>
          <p>This is a simple card using Cortex's UI components.</p>
          <Button onClick={handleClick} style={{ marginTop: "16px" }}>
            Click Me!
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export default App;
